import { defineStore } from 'pinia'

export enum ExportStatus {
  INACTIVE,
  EXPORTING,
  COMPLETE,
  ERROR
}
export interface ExportState {
  downloadLink: string | null
  durationMilliseconds: number
  elapsedMilliseconds: number
  fileFormat: string,
  fileName: string,
  exportStatus: ExportStatus
}

export const useExportStore = defineStore('exportStore', {
  state: (): ExportState => ({
    downloadLink: null,
    durationMilliseconds: 0,
    fileFormat: 'mp4',
    elapsedMilliseconds: 0,
    fileName: 'video.mp4',
    exportStatus: ExportStatus.INACTIVE
  })
})
